import script from "./ChooseDish.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseDish.vue?vue&type=script&setup=true&lang=js"

import "./ChooseDish.vue?vue&type=style&index=0&id=05dd9133&lang=css"

const __exports__ = script;

export default __exports__